import Link from "@iso/components/Link/Link";
import IntlMessages from "@iso/components/utility/intlMessages";
import { Button, Checkbox, Form, Input } from "antd";
import React, { useRef, useState } from "react";
import SignInStyleWrapper from "./SignIn.styles";
import { SidePanel } from "../../../components/SidePanel/SidePanel";
import { Navbar } from "../../../components/Navbar/Navbar";
import { useAuth } from "../../../contexts/auth";
import { useNavigate } from "react-router-dom";
import { createNotification } from "../../../components";

export default function SignIn() {
  const { Login } = useAuth();
  const navigate = useNavigate();
  const emailRef = useRef();
  const passwordRef = useRef();
  const [loading, setLoading] = useState(false);

  async function handleLogin(e) {
    e.preventDefault();

    setLoading(true);

    const payload = {
      email: emailRef.current.input.value,
      password: passwordRef.current.input.value,
    };

    Login(payload)
      .then(() => {
        navigate("/");
      })
      .catch((err) => {
        if (err.response) {
          createNotification("error", err.response.data.message);

          if (err.response.data.code === 'email_not_verified') {
            navigate("/confirm-email/" + payload.email);
          }
        } else {
          createNotification("error", "Network error");
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }

  return (
    <>
      <Navbar />
      <SignInStyleWrapper>
        <div className="isoLoginContentWrapper">
          <div className="isoLoginContent">
            <h3 className="text-xl">
              <IntlMessages id="page.signInTitle" />
            </h3>
            <div className="isoSignInForm">
              <Form layout="vertical">
                <Form.Item
                  name="email"
                  label="E-mail"
                  rules={[
                    {
                      required: true,
                      message: "Please input your email!",
                    },
                  ]}
                >
                  <Input
                    type="email"
                    placeholder="saffe@saffe.com"
                    size="large"
                    ref={emailRef}
                  />
                </Form.Item>
                <Form.Item
                  name="password"
                  label="Password"
                  rules={[
                    { required: true, message: "Please input your Password!" },
                  ]}
                >
                  <Input
                    type="password"
                    placeholder="********"
                    size="large"
                    ref={passwordRef}
                  />
                </Form.Item>
                <div className="flex justify-between items-center">
                  <Form.Item>
                    <Checkbox>Remember me</Checkbox>
                  </Form.Item>
                  <Form.Item>
                    <Link
                      style={{ display: "inherit", marginTop: "10px" }}
                      to="/forgot-password"
                      className="isoForgotPass"
                    >
                      <IntlMessages id="page.signInForgotPass" />
                    </Link>
                  </Form.Item>
                </div>
                <div className="flex justify-between items-center">
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <IntlMessages id="page.signInCreateAccount" />
                    <Link
                      className="text-primary hover:text-primary cursor-pointer"
                      to="/register"
                    >
                      <IntlMessages id="page.signInCreateAccountLink" />
                    </Link>
                  </div>
                  <Button
                    className="bg-primary border-0 text-white !px-8 shadow-none"
                    size="large"
                    htmlType="submit"
                    shape="round"
                    type="primary"
                    loading={loading}
                    onClick={handleLogin}
                  >
                    <IntlMessages id="page.signInButton" />
                  </Button>
                </div>
              </Form>
            </div>
          </div>
        </div>
        <SidePanel />
      </SignInStyleWrapper>
    </>
  );
}
